// extracted by mini-css-extract-plugin
module.exports = {"container":"Application_container__3FzfA","title":"Application_title__PgNvQ","buttonsWrapper":"Application_buttonsWrapper__1SvkO","alert":"Application_alert__1H6Z1"};